import React from 'react'

export default () => (
  <section id="business">
    <div className="section_title">
        <p>BUSINESS</p>
        <h2>ソルパックの事業内容</h2>
        <div className="title_label" />
    </div>
    <div className="section_contents">
        <div className="business_txt">
        <p>世の中にIT企業はたくさんあります。<br />便利なソフトウェアもたくさんあります。<br />しかし、道具はきちんと使えて初めて真価を発揮します。<br />SOLPACはソフトウェアをただ販売するのではなく、<br />適切に導入し、そのソフトウェアを最大限に使えるようにお客様をサポートする<br />お客様に笑顔で使っていただくことまでをサービスとし、導入支援・サポートにこそSOLPACの強さがあります。</p>
        </div>
        <div className="business_list">
        <div className="business_item">
            <div className="box">
            <p className="num">01</p>
            <h3>ソフトウェア製品</h3>
            <p className="txt">多数の海外パートナーと提携して、高品質かつ高実績のソフトウェア製品を提供します。</p>
            </div>
        </div>
        <div className="business_item">
            <div className="box">
            <p className="num">02</p>
            <h3>導入サポート</h3>
            <p className="txt">導入・運用・保守までトータルにサポートし、製品を正しく適切に使用していただきます。</p>
            </div>
        </div>
        <div className="business_item">
            <div className="box">
            <p className="num">03</p>
            <h3>システム開発</h3>
            <p className="txt">IBMi(AS/400)をはじめとする多岐にわたるシステムの構築から運用保守までワンストップサービスで提供します。</p>
            </div>
        </div>
        </div>
      </div>
    </section>
)


// WEBPACK FOOTER //
// ./src/Home/Business.js